import { RequirementParams } from "@/backend/access/requirement/types";
import { useRequirementsStore } from "@/frontend/store/RequirementsStore";
import { I18n } from "@/i18n/I18n";
import { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";

interface EditRequirementModalProps {
  requirement: RequirementParams;
  show: boolean;
  onHide: () => void;
}

export function EditRequirementModal({ requirement, show, onHide }: EditRequirementModalProps) {
  const updateRequirement = useRequirementsStore(state => state.updateRequirement);
  const [name, setName] = useState(requirement.name);
  const [description, setDescription] = useState(requirement.description);
  const [identifier, setIdentifier] = useState(requirement.identifier ?? '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setName(requirement.name);
      setDescription(requirement.description);
      setIdentifier(requirement.identifier ?? '');
    }
  }, [show, requirement]);

  const handleClose = () => {
    onHide();
    setName('');
    setDescription('');
    setIdentifier('');
  };

  const handleSave = async () => {
    setIsSubmitting(true);
    const success = await updateRequirement(requirement.id, { name, description, identifier: identifier.trim() || null });
    setIsSubmitting(false);
    if (success) {
      handleClose();
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.get('editRequirement')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>{I18n.get('title')}</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="text-body-secondary small">{I18n.get('identifier')} ({I18n.get('optional')})</Form.Label>
            <Form.Control
              type="text"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              className="form-control-sm"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>{I18n.get('description')}</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isSubmitting}>
          {I18n.get('cancel')}
        </Button>
        <Button variant="primary" onClick={() => void handleSave()} disabled={isSubmitting}>
          {isSubmitting ? I18n.get('saving') : I18n.get('save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

